"use client"

import { forwardRef, useState, useMemo } from "react"
import { Eye, EyeOff,Check,CircleAlert } from "lucide-react"
import { Input } from "../../ui/input"


const defaultValidationRules = [
  {
    id: "uppercase",
    label: "ABC",
    test: (password) => /[A-Z]/.test(password),
  },
  {
    id: "lowercase",
    label: "abc",
    test: (password) => /[a-z]/.test(password),
  },
  {
    id: "number",
    label: "123",
    test: (password) => /\d/.test(password),
  },
   {
    id: "length",
    label: "Min 8 characters",
    test: (password) => password.length >= 8,
  },
]

export const PasswordValidationField = forwardRef(
  (
    {
      item,
      value,
      error,
      helperText,
      disabled,
      autoFocus,
      onChange,
      onBlur,
      className,
      showValidation = true,
      validationRules = defaultValidationRules,
    },
    ref,
  ) => {
    const [showPassword, setShowPassword] = useState(false)

    const validationState = useMemo(() => {
      if (!showValidation) return []

      return validationRules.map((rule) => ({
        ...rule,
        isValid: value ? rule.test(value) : false,
      }))
    }, [value, showValidation, validationRules])

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword)
    }

    return (
      <div className="space-y-3">
        <div className="relative">
          <Input
            ref={ref}
            type={showPassword ? "text" : "password"}
            placeholder={item?.placeholder || "Enter your password"}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            autoFocus={autoFocus}
            className={`pr-10 ${error ? "border-red-500 hover:border-red-500 focus:border-red-500" : "border-gray-300"} ${
              className || ""
            }`}
            aria-describedby={helperText ? `${item?.pathToValue}-error` : undefined}
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            tabIndex={-1}
          >
            {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>

        {showValidation && (
          <div className="flex items-center gap-4 text-sm" style={{position:"relative", bottom:8}}>
            {validationState.map((rule) => (
              <div key={rule.id} className="flex items-center gap-1">
                <span
                  className={`inline-flex items-center justify-center w-[10px] h-[10px] rounded-[1rem] text-xs font-medium ${
                    rule.isValid ? "bg-green-600 text-white" : "bg-red-600 text-white"
                  }`}
                >
                  {rule.isValid ? <Check/> : <CircleAlert />}
                </span>
                <span className={`text-gray-400 whitespace-nowrap`} style={{fontSize:10}}>{rule.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  },
)

// PasswordField.displayName = "PasswordField"
